import * as React from 'react';

export class ProgressBar extends React.Component<
    {
        style?;
    },
    {}
> {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="progress" style={this.props.style}>
                <div
                    className="progress-bar"
                    style={{
                        width: '100%'
                    }}
                ></div>
            </div>
        );
    }
}
